export default {
  methods: {
    /**
     * API実行時にでエラーが発生した際のメッセージハンドリング
     * 400番台のエラーの場合に、APIから返却されたエラーメッセージを表示するために利用することを想定
     * @param {Object} error - APIから返却されたエラーオブジェクト
     * @param {string} defaultMessage - 400番台ではないエラーの場合に表示するメッセージ
     */
    resolveErrorMessage(error, defaultMessage) {
      // エラーオブジェクトが想定外の場合
      if (!error || !error.response || !error.response.status) {
        console.error(error)
        return this.__createExceptionMessage(error, defaultMessage)
      }

      // 400番台以外のエラーの場合
      if (error.response.status < 400 || error.response.status >= 500) {
          console.error(error.response)
          return this.__createExceptionMessage(error, defaultMessage)
      }

      // エラーオブジェクトからメッセージが取得できない場合
      if (!error.response.data || !error.response.data.errors) {
        console.error(error.response)
        return this.__createExceptionMessage(error, defaultMessage)
      }

      return error.response.data.errors.reduce((prev, current, currentIndex) => {
        if (currentIndex > 0) {
          prev += '\n'
        }
        return prev + current.message
      }, '')
    },

    /**
     * 例外メッセージ生成
     * @param {Object} error - APIから返却されたエラーオブジェクト
     * @param {string} defaultMessage - API戻り値からメッセージ取得できない場合に表示するメッセージ
     */
    __createExceptionMessage(error, defaultMessage) {
      let message = defaultMessage

      if (error?.response?.status) {
        message = message + ' (' + String(error.response.status) + ')'
      }

      if (error?.response?.status == 504) {
        // APIGatewayのtimeout
        message = this.$t('MSG0133')
      } else if (error?.response?.data?.message) {
        // APIGateway標準エラー
        message = message + '\n\n' + error.response.data.message
      } else if (!error?.response && error?.message) {
        // ネットワーク問題など
        message = message + '\n\n' + error.message
      }  

      return message
    },

    /**
     * APIの結果がNotFoundかどうかの判定処理
     * @param {Object} error - APIから返却されたエラーオブジェクト
     */
    isNotFound(error) {
      // エラーオブジェクトが想定外の場合
      if (!error || !error.response || !error.response.status) {
        return false
      }
      return error.response.status === 404
    },
  },
}
